import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SimpleSearch } from "../../../../../../../reduxToolkit/Search/SearchApi";
import { SEARCH_MODEL } from "../../../../../../../components/table/Model/TableModel";
import { TABLES } from "../../../../../../../Apis/Tables";
import {filterByName} from "../../../../../../../Apis/functions";
import { DocumentLinesIcon } from "../../../../../../../components/buttons/IconButtons";
import DeductionPolicyCard from "../SubComponents/DeductionPolicyCard";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const AddGlobalDeductionsApp = ({ id }) => {
    const { t } = useTranslation();

    const isCreate = id === null || id === undefined;

    const renderAvailableItem = ({ item, disabled, onAdd }) => (
        <DeductionPolicyCard item={{ ...item, disabled }} onAdd={onAdd} />
    );

    const renderSelectedItems = ({ items, keyId, selectedSearchElement, handleDelete }) =>
        filterByName(items, selectedSearchElement)?.map((item, index) => (
            <div className="mb-3" key={item[keyId] ?? index}>
                <DeductionPolicyCard item={item} onDelete={handleDelete} />
            </div>
        ));

    const dynamicConfig = useMemo(() => ({
        api: SimpleSearch,
        keyId: 'id',
        labelRowsPerPage: 'deductions_per_page',
        tableNotInformationLegend: 'no_records_available',
        titleContainer: 'global_deductions',
        selectTitleContainer: 'excluded_global_deductions',
        searchLabel: 'search',
        selectedSectionIconTitle: (
            <DocumentLinesIcon height={18} width={18} className="mr-8px mb-1 icon-color-general-950" />
        ),
        buildBody: ({ page, rowsPerPage, searchElement }) => ({
            body: SEARCH_MODEL.setObject({
                page,
                size: rowsPerPage,
                key: searchElement,
                model: id ? TABLES.PAYROLL_DEDUCTION_POLICY_NOT_EXCLUDED : TABLES.PAYROLL_DEDUCTION_POLICY,
                modelId: id,
            }),
        }),
        renderAvailableItem,
        renderSelectedItems,
    }), [isCreate, id]);

    return { t, dynamicConfig };
};
